import { assessmentsConstants } from '../../_constants';
import { assessmentsService } from '../../_services';

export const respondentsAssessmentAction = {
    respondentsAssessmentHandler
};

function respondentsAssessmentHandler(data, currentDashboardObj, callback) {
    return dispatch => {
        dispatch(request());
        assessmentsService.respondentsAssessmentHandler(data, currentDashboardObj)
            .then(
                respondentsAssessment => {
                    dispatch(success(respondentsAssessment));
                    if(callback) {
                        callback(respondentsAssessment)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: assessmentsConstants.REQUEST_RESPONDENTS_ASSESSMENT} }
    function success(respondentsAssessment) { return { type: assessmentsConstants.RECEIVE_RESPONDENTS_ASSESSMENT, respondentsAssessment } }
    function failure(error) { return { type: assessmentsConstants.RESPONDENTS_ASSESSMENT_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/Assessments/respondentsAssessment.action.js